import styled from 'styled-components'

import type { FC } from 'react'

type HighlightedTextProps = {
  text: string
  segments?: Array<{ text: string; highlight: boolean }>
  highlightColor?: string
}

/**
 * Component that highlights matching text in a string based on a list of segments
 */
export const HighlightedText: FC<HighlightedTextProps> = ({ text, highlightColor, segments }) => {
  if (!segments) return <>{text}</>

  return (
    <>
      {segments.map((segment, index) =>
        segment.highlight ? (
          <StyledMark key={index} highlightColor={highlightColor}>
            {segment.text}
          </StyledMark>
        ) : (
          segment.text
        ),
      )}
    </>
  )
}

const StyledMark = styled.span<{ highlightColor?: string }>`
  background-color: ${({ highlightColor }) => highlightColor ?? '#fef08a'};
  border-radius: 0.125rem;
  padding: 0 0.125rem;
`
